import { ContentCard } from "sj-ui-toolkit/src/atlas/components";

export const LessonsContainer = ({ title, lessons = [], inPath = false }) => {
  return (
    <div className="py-8">
      <h2 className="atlas-h5">{title}</h2>
      <div className="flex flex-wrap gap-6 mt-4">
        {lessons.map(lesson => (
          <ContentCard key={lesson.id} {...lesson} inPath={inPath} type="lesson" />
        ))}
      </div>
    </div>
  );
};
